import { Switch } from '@mui/material'
import React from 'react'
import { newBaseUrl } from '../../utils/capitalRequest';
import { requestPatch } from '../../utils/request';

const SwichComp = (props) => {
  const {name, value, setChecked, checked, item} = props;

  const handleChange = async (event) => {
    let userId = item?.id;
    let params = {
      "email":item.email,
      "name":item.name,
      "first_name":item.first_name,
      "last_name":item.last_name,
      "mobile":item.mobile,
      "password":item.password,
      "roles":item.roles[0].id
    };

    let c_checked = event.target.checked;
    params = {...params, is_vdr:c_checked}
    // console.log(event.target.checked, userId, params);
    await requestPatch.patch(`${newBaseUrl}/admin/users/${userId}`, params).then(res=>{
      console.log(res.data)
    }).catch(err=>{
      console.log(err)
    })
    // console.log(event.target.name);
    setChecked({...checked, [event.target.name]:c_checked});
  };
  
  
  return (
    <>
         <Switch
            checked={checked[name]}
            name={name}
            onChange={handleChange}
            inputProps={{ 'aria-label': 'controlled' }}
        />
    </>
  )
}

export default SwichComp